import React from 'react'
import { connect } from 'react-redux'
import find from 'lodash/find'

import {
    selectPaymentOption
} from './paymentMethodActionCreators'

import {
    OptionListItemRadio,
    CheckoutSection,
    hiddenAnchorStyle
} from '../../components'

import { Fade } from '../../componentAnimations'
import { PurchaseOrderComponent } from '.'

const getById = (methods, id) => {
    return methods.filter(pm => pm.Id === id)[0];
}

class CheckoutPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: false
        }
        this.onItemSelected = this.onItemSelected.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.onPaymentIsValid = this.onPaymentIsValid.bind(this)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.orderTotal !== this.props.orderTotal
            && this.props.purchaseOrderAvailableCredit < this.props.orderTotal
            && this.props.selectedPaymentOptionId === this.props.purchaseOrderPaymentId) {
            this.props.onCancel();
            this.setState({ isCollapsed: false });
        }
    }

    onPaymentIsValid() {
        this.setState({ isCollapsed: true });
    }

    onItemSelected(id) {
        const paymentOption = getById(this.props.paymentOptions, id);
        if (!paymentOption) {
            console.error(`No payment method with id '${id}'`);
            return;
        }
        if (!paymentOption.paymentOptionComponent) {
            this.setState({ isCollapsed: true });
        }
        this.props.onSelected(id, paymentOption.Name);
    }

    onClickChange(e) {
        e.preventDefault();
        this.setState({ isCollapsed: !this.state.isCollapsed });
    }



    render() {
        const items = this.props.paymentOptions.map(pm => {
            let selected = pm.Id === this.props.selectedPaymentOptionId;
            if (pm.paymentOptionComponent) {
                const PaymentOptionComponent = pm.paymentOptionComponent;

                let isPurchaseOrder = pm.Id === this.props.purchaseOrderPaymentId,
                    disabled = false,
                    secondaryLabel = "";

                if (isPurchaseOrder) {
                    disabled = this.props.purchaseOrderStatusOnHold || this.props.orderTotal > this.props.purchaseOrderAvailableCredit;
                    secondaryLabel = disabled ? (this.props.purchaseOrderStatusOnHold ? " - Account on Hold" : " - Above Credit Limit") : "";
                }

                return (
                    <React.Fragment key={pm.Id}>
                        <OptionListItemRadio
                            id={pm.Id}
                            isSelected={selected}
                            onClick={this.onItemSelected}
                            label={pm.Name + secondaryLabel}
                            disabled={disabled}>
                            <div className='col-xs-12'>
                                <PaymentOptionComponent
                                    isSelected={selected}
                                    onPaymentIsValid={this.onPaymentIsValid}
                                    onPaymentCancel={this.props.onCancel}
                                    disabled={disabled}
                                />
                            </div>
                        </OptionListItemRadio>
                        <div className="clearfix"></div>
                    </React.Fragment>
                );
            } else {
                return (<OptionListItemRadio
                    key={pm.Id}
                    id={pm.Id}
                    isSelected={selected}
                    onClick={this.onItemSelected}
                    label={pm.Name} />);
            }
        }, this);
        const canChange = true,
              purchaseOrderSelected = this.props.selectedPaymentOptionId === this.props.purchaseOrderPaymentId;
        return (
            <CheckoutSection label={"Payment Information"} hidden={false}>
                <div style={{ lineHeight: 2 }}>
                    <button
                        className="btn btn-link"
                        style={hiddenAnchorStyle}
                        onClick={(e) => this.onClickChange(e)}
                    >
                        {this.props.selectedDisplay || <em>Select Payment Method</em>}
                        {canChange &&
                            <span style={{ marginLeft: 20, color: '#004af4', fontWeight: 600 }}>
                                {this.state.isCollapsed ? 'Change' : 'Done'}
                            </span>}
                    </button>
                </div>
                <Fade inProp={!this.state.isCollapsed}>
                    <div style={{ display: this.state.isCollapsed ? 'none' : 'inherit' }}>
                        {items}
                    </div>
                </Fade>
                {!purchaseOrderSelected && (
                    <React.Fragment>
                        <br/>
                        <div className="row">
                            <PurchaseOrderComponent isOptional={true} />
                        </div>
                        <div className="clearfix" />
                    </React.Fragment>)
                }
            </CheckoutSection>
        );
    }
}

const formatPayment = ({ constants, entities }) => {

    const formatPaypalPayloadDetailsForSummary = (det) => {
        if (det) {
            if (typeof (det.firstName) !== 'undefined' && typeof (det.lastName) !== 'undefined' && typeof (det.email) !== 'undefined') {
                return `${det.firstName.length > 0 ? det.firstName + " " : ""}${det.lastName.length > 0 ? det.lastName + " " : ""} (${det.email})`;
            } else if (typeof (det.email) !== 'undefined' && det.email.length > 0) {
                return det.email;
            }
        }
        return "unspecified";
    }

    let formatters = [
        {
            Id: constants.purchaseOrderPaymentId,
            format: ({ POValue }) => (`Purchase Order ${((POValue && POValue.length > 0) ? " #: " : "")}${POValue || ""}`)
        },
        {
            Id: constants.acceptJsSettings.acceptJsPaymentId,
            format: ({ AcceptJsPaymentPayload, AuthorizeDotNetPaymentProfileId, AcceptJsClientPaymentMethods }) => {
                if (AcceptJsPaymentPayload) {
                    return "Credit Card";
                } else if (AuthorizeDotNetPaymentProfileId) {
                    const method = AcceptJsClientPaymentMethods.find(m => m.customerPaymentProfileId == AuthorizeDotNetPaymentProfileId);
                    return method ? `Credit Card: ${method.maskedCardNumber}` : 'Pending';
                } else {
                    return "Pending";
                }
            }
        },
    ];
    const formatter = find(formatters, x => x.Id === entities.SelectedPaymentOptionId);
    if (formatter) {
        return formatter.format(entities.PaymentRecord);
    }
}

const mapCheckoutPaymentStateToProps = (state) => {
    return {
        paymentOptions: state.entities.PaymentOptions,
        selectedPaymentOptionId: state.entities.SelectedPaymentOptionId,
        selectedDisplay: formatPayment(state),
        orderTotal: state.entities.Summary.total,
        purchaseOrderPaymentId: state.constants.purchaseOrderPaymentId,
        purchaseOrderAvailableCredit: state.entities.purchaseOrderAvailableCredit,
        purchaseOrderStatusOnHold: state.entities.purchaseOrderStatusOnHold
    }
}

const mapCheckoutPaymentDispatchToProps = (dispatch) => {
    return {
        onSelected: (id, displayName) => dispatch(selectPaymentOption(id, displayName)),
        onCancel: () => dispatch(selectPaymentOption(''))
    }
}

const CheckoutPaymentContainer = connect(
    mapCheckoutPaymentStateToProps,
    mapCheckoutPaymentDispatchToProps
)(CheckoutPayment);


export default CheckoutPaymentContainer